import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CryptoTool from "../../../utils/CryptoTool";
import { initRecharge, loginShopifyAppProxy, getCustomer, listCharges } from '@rechargeapps/storefront-client';
import { getShopDomain, getRechargeToken } from '../../../constants/bundleConfig';
import API from "../../../utils/API";
import styled from "styled-components";
import Loaders from "./components/loaders";
import PageTemplate from "../../templates/PageTemplate";
import UpcomingDeliveries from "../../organisms/UpcomingDeliveries";
import EditQuantity from "../../organisms/EditQuantity";
import MealSelectorContent from "../../organisms/MealSelectorContent";
import NoChargeOrderReceived from "../../atoms/NoChargeOrderReceived";


import { getCurrentDietType, getProductDietTypeFromSku, filterOutOrders } from "../../../utils/functions";

const Wrap = styled.div`
  max-width: ${(props) => props.theme.sizes.maxWidth};
  margin: 0 auto;
  padding-top: 22px;
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 990px) {
    padding-top: 90px;
  }
`;

const shopUrl = CryptoTool.getShopUrl();
const DefaultUser = CryptoTool.getDefaultUser();

function CustomerPortal(props) {
  const { customerId, redirectEditQuantity, mealSettings } = props;
  const [isLegacyCustomer, setIsLegacyCustomer] = useState(false);
  const [step, setStep] = useState(1);
  const [exclusions, setExclusions] = useState([]);
  const [diets, setDiets] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [additionals, setAdditionals] = useState([]);
  const [charges, setCharges] = useState([]);
  const [orders, setOrders] = useState([]);
  const [meals, setMeals] = useState([]);
  const [bundlesByCharge, setBundlesByCharge] = useState([]);
  const [upcomingDeliveryMeals, setUpcomingDeliveryMeals] = useState([]);
  const [editChargeId, setEditChargeId] = useState("");
  const [editSubscription, setEditSubscription] = useState({
    breakfasts: 0,
    entrees: 0,
    selectedExclusions: [],
  });
  const [isCustomerActive, setIsCustomerActive] = useState(null);
  const [orderAndChargeDataReceived, setOrderAndChargeDataReceived] = useState(null);
  const [isOldUser, setIsOldUser] = useState(false);
  const [dietType, setDietType] = useState("Low-FODMAP Plan");
  const [main_title, setMain_title] = useState("Low-FODMAP Plan");

  const prevCharges = useRef();

  useEffect(() => {
    getSubscriptionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    prevCharges.current = charges;
    if (redirectEditQuantity && prevCharges.current.length === 0 && charges.length) {
      setStep(3);
      setEditChargeId(charges[0].id);
    }
  }, [charges, redirectEditQuantity]);

  const getBundlesByCharge = async (chargeId) => {
    const {addressId} = charges.find(charge => charge.id === chargeId);
    const customerEmail = window.theme.customerEmail;

    const url = `/tools/softserve/api/products/bundles/subscription?addressId=${addressId}&customer_id=${customerId}`;

    try {
      const response = await API.get(CryptoTool.cryptUrl(url, customerEmail, true));;
      const bundles = response.data;
      setBundlesByCharge(bundles);
    } catch (error) {
        console.error('Error fetching bundles:', error);
    }
  };

  const getVariantSKU = (data) => {
    let BreakException = {};
    let sku = "";
    try {
      data.forEach((order) => {
        order.meals.forEach((meal) => {
          meal.variants.forEach((variant) => {
            sku = variant.sku;
            throw BreakException;
          });
        });
      });
    } catch (e) {}

    return sku;
  };

  const setOrderAndChargeDataReceivedMark = (orders, subscriptionData) => {
    return orders.length > 0 || subscriptionData.charges.length > 0 ? true : false;
  };

  const addTitlePropertyToItems = (data) => {
    data.forEach((el) => {
      let SKU = el.meals[0].variants[0].sku;
      el["main_title"] = getProductDietTypeFromSku(SKU);
    });
  };

  const subscriptionDataQuery = async () => {
    const url = `${shopUrl}/api/customers/${customerId}/upcomingDeliveries`;
    const customerEmail = window.theme.customerEmail;

    let subscriptionData = await API.get(CryptoTool.cryptUrl(url, customerEmail, true));

    return { ...subscriptionData.data };
  };


const getSubscriptionData = async () => {
  const menuMyHealthReport = document.getElementById("menu_my_health_report");
  let subscriptionData;
  let dType = "Low-FODMAP Plan";

  try {
    subscriptionData = await subscriptionDataQuery();
    const orders = filterOutOrders(subscriptionData.orders);
    const charges = [...subscriptionData.charges];
    
    setExclusions(subscriptionData.exclusions);
    setCharges(charges);
    setOrders(orders);
    
    const allMeals = [];
    charges.forEach(charge => {
      charge.meals?.forEach(meal => allMeals.push(meal));
    });
    setUpcomingDeliveryMeals(allMeals.length > 0 ? allMeals : [{ id: 'dummy' }]);
    
    setMeals(allMeals);
    
    if (orders.length > 0 && orders[0].meals?.length > 0) {
      const sku = orders[0].meals[0].variants?.[0]?.sku;
      if (sku && typeof sku === 'string') {
        dType = getProductDietTypeFromSku(sku);
        setDietType(dType);
      }
    } else if (charges.length > 0 && charges[0].meals?.length > 0) {
      const sku = charges[0].meals[0].variants?.[0]?.sku;
      if (sku && typeof sku === 'string') {
        dType = getProductDietTypeFromSku(sku);
        setDietType(dType);
      }
    }
    
    charges.forEach(charge => {
      if (charge.meals?.length > 0 && charge.meals[0].variants?.[0]?.sku) {
        const sku = charge.meals[0].variants[0].sku;
        if (sku && typeof sku === 'string') {
          charge.main_title = getProductDietTypeFromSku(sku);
        } else {
          charge.main_title = dType;
        }
      } else {
        charge.main_title = dType;
      }
    });
    
    orders.forEach(order => {
      if (order.meals?.length > 0 && order.meals[0].variants?.[0]?.sku) {
        const sku = order.meals[0].variants[0].sku;
        if (sku && typeof sku === 'string') {
          order.main_title = getProductDietTypeFromSku(sku);
        } else {
          order.main_title = dType;
        }
      } else {
        order.main_title = dType;
      }
    });
    
    setOrderAndChargeDataReceived(orders.length > 0 || charges.length > 0);
    setIsCustomerActive(true);
    
    if (menuMyHealthReport) {
      menuMyHealthReport.href = `/pages/my-health-report?dietType=${dType}`;
    }
    
  } catch (error) {
    setIsCustomerActive(false);
  }
};

  const filterOutMeals = (data, types) => {
    return data.filter((meal) => {
      let found = false;

      meal.tags.forEach((tag) => {
        types.forEach((type) => {
          if (tag.toLowerCase() === type) {
            found = true;
            return true;
          }
        });
      });

      return found;
    });
  };

  const handleChangeQuantity = (id, deliveryDietType) => {
    const _dietType = getCurrentDietType(deliveryDietType);
    setStep(3);
    setEditChargeId(id);
    setMain_title(_dietType);
    setDietType(_dietType);
    if (!bundlesByCharge.length || id !== editChargeId) {
      getBundlesByCharge(id);
    }
  };

const getSelectedExclusions = (exCodes, exclusions, dietType) => {

  let exclusionCodes = exCodes !== null ? exCodes : "";
  
  let selectedExclusions = [];

  let type = '';
  if (dietType === 'Low-FODMAP Plan' || dietType === 'Gluten-Free Plan' || dietType === 'Carb-Conscious Plan' || dietType === 'B2B Plan' || dietType === 'GLP-1 Plan') {
    type = 'FL-';
  } else if (dietType === 'Care Plan') {
    type = 'CM-';
  } else {
    type = 'MD-';
  }

  const exclusionCodesArray = exclusionCodes && exclusionCodes.length ? exclusionCodes.split(",") : [];
  const fullExcludeSku = exclusionCodesArray.map(code => type + code);
  
  exclusions.forEach((element) => {
    let sku = element.sku;
    
    if (!sku || typeof sku !== 'string') {
      return;
    }
    
    fullExcludeSku.forEach((code) => {
      if (sku.includes(code)) {
        selectedExclusions.push(element.name);
      }
    });
  });

  return [...new Set(selectedExclusions)];
};

 const handleEditDelivery = (id, deliveryDietType) => {
  const charge = charges.filter((item) => item.id === id);
  
  let selectedBreakfasts = filterOutMeals(charge[0].meals, ["breakfast"]);
  let selectedEntrees = filterOutMeals(charge[0].meals, ["entrée"]);

  let excludeCodes = getSelectedExclusions(charge[0].excludeCodes, exclusions, deliveryDietType);

  let breakfastQuantity = 0;
  let entreeQuantity = 0;
  selectedBreakfasts.forEach((meal) => (breakfastQuantity += meal.quantity));
  selectedEntrees.forEach((meal) => (entreeQuantity += meal.quantity));

  setStep(2);
  setEditChargeId(id);
  setEditSubscription({
    breakfasts: breakfastQuantity,
    entrees: entreeQuantity,
    selectedExclusions: excludeCodes,
  });
  setMain_title(deliveryDietType);
  setDietType(deliveryDietType);
};

  const handleBackClick = () => {
    setStep(1);
    setEditChargeId(null);
    setEditSubscription({
      breakfasts: 0,
      entrees: 0,
      selectedExclusions: [],
    });
  };

  const saveQuantityData = (data) => {
    setStep(2);
    setEditSubscription({
      breakfasts: data.breakfasts,
      entrees: data.entrees,
      selectedExclusions: data.selectedExclusions,
    });
  };

  const handleClickEditQuantity = () => {
    setStep(3);
  };

  let _charges = [...charges];

  let getChargeObj = () => {
    let charge = {};

    _charges.forEach((item) => {
      if (item.id === editChargeId) charge = item;
    });

    return { ...charge };
  };

  const checkOrdersAndChargesReceived = () => {
    const ordersAndCharges = orders.length > 0 || _charges.length > 0 ? true : false;
    const subscriptionData = isCustomerActive === true && upcomingDeliveryMeals.length > 0 ? true : false;

    if (ordersAndCharges && subscriptionData) {
      return true;
    } else if (!ordersAndCharges && subscriptionData) {
      return false;
    } else if (isCustomerActive === false) {
      return false;
    } else if (isCustomerActive === null) {
      return true;
    }
  };

  const checkOrdersReceived = () => {
    return orders.length > 0;
  };

  let ordersAndChargesReceived = checkOrdersAndChargesReceived();
  let ordersReceived = checkOrdersReceived();

  let chargeObj = getChargeObj();

  return (
    <PageTemplate>
      {((isCustomerActive === false && !ordersReceived) || (!ordersAndChargesReceived && !ordersReceived)) && <NoChargeOrderReceived />}

      {isCustomerActive === false && ordersReceived && (
        <Wrap>
          <UpcomingDeliveries
            customerId={customerId}
            charges={charges}
            orders={orders}
            exclusions={exclusions}
            dietType={dietType}
            handleChangeQuantity={handleChangeQuantity}
            handleEditDelivery={handleEditDelivery}
            isOldUser={isOldUser}
            isCustomerActive={isCustomerActive}
          />
        </Wrap>
      )}
      <Loaders
        upcomingDeliveryMeals={upcomingDeliveryMeals}
        redirectEditQuantity={redirectEditQuantity}
        isCustomerActive={isCustomerActive}
        orderAndChargeDataReceived={orderAndChargeDataReceived}
      />
      {step === 1 && ordersAndChargesReceived && isCustomerActive && (
        <Wrap>
           <UpcomingDeliveries
            customerId={customerId}
            charges={charges}
            orders={orders}
            exclusions={exclusions}
            dietType={dietType}
            handleChangeQuantity={handleChangeQuantity}
            handleEditDelivery={handleEditDelivery}
            isOldUser={isOldUser}
            isCustomerActive={isCustomerActive}
          />
        </Wrap>
      )}
      {step === 2 && upcomingDeliveryMeals.length > 0 && orderAndChargeDataReceived !== false && (
        <MealSelectorContent
          customerId={customerId}
          meals={meals}
          upcomingDeliveryMeals={upcomingDeliveryMeals}
          diets={diets}
          additionals={additionals}
          exclusions={exclusions}
          editChargeId={editChargeId}
          mode={"account"}
          charge={chargeObj}
          handlePrevClick={handleBackClick}
          editSubscription={editSubscription}
          handleClickEditQuantity={handleClickEditQuantity}
          redirectEditQuantity={redirectEditQuantity}
          mealSettings={mealSettings}
          passedDownExlusions={editSubscription.selectedExclusions}
          dietType={dietType}
          main_title={main_title}
        />
      )}
      {step === 3 && upcomingDeliveryMeals.length > 0 && orderAndChargeDataReceived !== false && (
        <Wrap>
          <EditQuantity
            customerId={customerId}
            exclusions={exclusions}
            dietType={dietType}
            editChargeId={editChargeId}
            handleBackClick={handleBackClick}
            saveQuantityData={saveQuantityData}
            redirectEditQuantity={redirectEditQuantity}
            mealSettings={mealSettings}
            main_title={main_title}
            charges={charges}
            bundles={bundlesByCharge}
          />
        </Wrap>
      )}
    </PageTemplate>
  );
}

CustomerPortal.propTypes = {
  customerId: PropTypes.number,
  redirectEditQuantity: PropTypes.bool,
  mealSettings: PropTypes.object,
};

export default CustomerPortal;
